import { render, staticRenderFns } from "./HotKeys.vue?vue&type=template&id=62192453"
import script from "./HotKeys.vue?vue&type=script&lang=js"
export * from "./HotKeys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports